import _classCallCheck from "c:\\repo\\maketek-company-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "c:\\repo\\maketek-company-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "c:\\repo\\maketek-company-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "c:\\repo\\maketek-company-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "c:\\repo\\maketek-company-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import hoistStatics from 'hoist-non-react-statics';
import withNavigation from './withNavigation';
export default function withNavigationFocus(Component) {
  var ComponentWithNavigationFocus =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(ComponentWithNavigationFocus, _React$Component);

    function ComponentWithNavigationFocus(props) {
      var _this;

      _classCallCheck(this, ComponentWithNavigationFocus);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ComponentWithNavigationFocus).call(this, props));
      _this.subscriptions = [props.navigation.addListener('didFocus', function () {
        return _this.setState({
          isFocused: true
        });
      }), props.navigation.addListener('willBlur', function () {
        return _this.setState({
          isFocused: false
        });
      })];
      _this.state = {
        isFocused: props.navigation ? props.navigation.isFocused() : false
      };
      return _this;
    }

    _createClass(ComponentWithNavigationFocus, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.subscriptions.forEach(function (sub) {
          return sub.remove();
        });
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(Component, _extends({}, this.props, {
          isFocused: this.state.isFocused,
          ref: this.props.onRef
        }));
      }
    }]);

    return ComponentWithNavigationFocus;
  }(React.Component);

  _defineProperty(ComponentWithNavigationFocus, "displayName", "withNavigationFocus(".concat(Component.displayName || Component.name, ")"));

  return hoistStatics(withNavigation(ComponentWithNavigationFocus, {
    forwardRef: false
  }), Component);
}